module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-bok2-8782fb7d0a38f0dde4ef887b85f3ce8e.svg";